import logger from '../utils/rbmc.logger';
import cartTooltip from '../cart/rbmc.cart-tooltip';
import cartData from '../cart/rbmc.cart-data';
import cartTracking from '../tracking/rbmc.tracking.cart'
import cartCounter from '../header/rbmc.cart-counter';
import pdpConfig from '../pdp/rbmc.pdp-configurator-field';
import pdpFlockingWFL from '../pdp/rbmc.wfl-flocking';
import productDetails from "./rbmc.pdp";
import consumerEvents from '../events/rbmc.events.consumer-events';
import urlUtils from '../utils/rbmc.url-utils';
import gigyaCustom from '../gigya/rbmc.gigya';

const pdpAddToCart = {
    bindHandler() {
        $(document.body).on('click', '#addToCartButton', pdpAddToCart.submitButtonHandler);
    },

    submitButtonHandler(evt) {
        evt.preventDefault();
        // logic for showing modal window is inside function
        productDetails.noReturnsInfo();
        productDetails.handleErrorMessage();
        // check if it's standard flocking or mandatory flocking
        const addToCartForm = $('#addToCartForm');
        const giftCardData  = productDetails.collectGiftCardData();

        if (giftCardData.isGiftCard) {
            pdpAddToCart.addToCart(
                    addToCartForm.attr('action'),
                    addToCartForm.find('#productCode').val(),
                    null, null, null, null,
                    giftCardData
            );
            return false;
        }

        if (pdpConfig.configurationArea.data('flock-mandatory')) {
            let form = $('#plp__wfl-flock-form');
            if (pdpFlockingWFL.validateBeforeSubmit() &&
                    pdpFlockingWFL.inputIsValid &&
                    pdpFlockingWFL.inputLocked) {
                pdpAddToCart.addToCart(
                        addToCartForm.attr('action'),
                        addToCartForm.find('#productCode').val(),
                        form.find('#pdp__wfl-flock-input').val(),
                        "NO_NUMBER"
                )
            }
        } else {
            pdpAddToCart.addToCart(
                    addToCartForm.attr('action'),
                    addToCartForm.find('#productCode').val(),
                    addToCartForm.find('#nameFlock').val(),
                    addToCartForm.find('#flockType').val(),
                    addToCartForm.find('#numberFlock').val(),
                    addToCartForm.find('#selectedPatches').val()
            )
        }
    },

    addToCart(...params) {
        const [url, productCode, nameFlock = '', flockType = '', numberFlock = '', patches = '', giftCard = {}] = params;

        const productData = {
            qty:             1,
            productCode:     productCode,
            nameFlock:       nameFlock,
            numberFlock:     numberFlock,
            type:            flockType,
            selectedPatches: patches,
        }

        const giftCardData = {
            qty:                     productData.qty,
            productCode:             productData.productCode,
            individualGiftCardValue: giftCard.amount,
            giftCardMessage:         giftCard.message
        }

        const requestData = giftCard.isGiftCard ? giftCardData : productData;

        $.post(url, requestData)
         .done(function (data) {
             //show animation etc...
             let error = $('.pdp__add-to-cart-error-wrapper');
             if (data.success) {
                 cartCounter.updateCounter(data.cartData.totalUnitCount);
                 //track consumer event
                 consumerEvents.trackAddToCartEvent(data.trackingProductData);
                 //track GTM dataLayer
                 cartTracking.addToCart(data.gtmProductData, 1);
                 pdpAddToCart.refreshMiniCart();
                 logger.log("Add to cart success! Data: ", requestData);

                 // Trigger archibald update - FLOCKED PRODUCT
                 gigyaCustom.isGigyaUserAuthenticated().then((isLoggedIn) => {
                     document.dispatchEvent(new CustomEvent("legacyCartUpdated", {
                         detail: !isLoggedIn ? data.cartData.guid : data.cartData.code
                     }));
                 });

             } else {
                 productDetails.handleErrorMessage(data.errors[0]);
             }
         }).fail(function (x, e) {
            logger.debug("Add to cart data failed! Log trace:", x);
        });
    },
    refreshMiniCart() {
        //open cart overlay on successful add to cart request
        cartData.refreshCartTooltip(() => {
            cartTooltip.openCartOverlay();
            cartTooltip.cartTimeout = setTimeout(cartTooltip.closeCart, 5000);
        });
    },
    addToCartArchibald(data) {
        const url = `${urlUtils.getBaseUrl()}cart/add`;

        return $.ajax({
            url:         url,
            method:      'POST',
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            dataType:    'json',
            data:        data
        });
    },

    /**
     * Set data into main config object, this will be sent to backend at the end.
     * It is important that this holds final user data.
     * @param name
     * @param number
     * @param type
     */
    setPersonalization(name, number, type) {
        if (name !== undefined) {
            $('#nameFlock').val(name);
            $('#numberFlock').val(number);
            $('#flockType').val(type);
        }
    },

    setPatches(patches) {
        $('#selectedPatches').val(patches);
    }
};

export default pdpAddToCart;
